import React from "react";

const ReportIcon = ( {image}) =>
{
    return (
        <img src={image} alt=''/>
    )
}

export default ReportIcon ;